import { pick } from './i18n.js';

const zh = {
  openingCanvas: '正在打开画布…',
  loadingFiles: '正在载入项目资料…',
  syncingTasks: '正在同步任务状态…',
  loadingProject: '加载设计项目',
  ready: 'Ready! 准备就绪…',
};
const en: typeof zh = {
  openingCanvas: 'Opening canvas…',
  loadingFiles: 'Loading project files…',
  syncingTasks: 'Syncing task status…',
  loadingProject: 'Loading design project',
  ready: 'Ready!',
};
export const stitchTransitionTextByLocale = { zh, en };
export const stitchTransitionText = pick<typeof zh>(stitchTransitionTextByLocale);
